const originalError = console.error;
let patched = false;
function suppressRefWarning(ownerName) {
  if (patched === false) {
    console.error = (...args) => {
      if (typeof args[0] === "string" && args[0].includes("Function components cannot be given refs.") && args[0].includes(`Check the render method of \`${ownerName}\`.`)) {
        return;
      }
      return originalError(...args);
    };
    patched = true;
  }
}
export {
  suppressRefWarning
};
//# sourceMappingURL=suppress-ref-warning.js.map